import { FetchBaseQueryError } from '@reduxjs/toolkit/query';
import jwtDecode from 'jwt-decode';
import { Dialog } from 'primereact/dialog';
import { classNames } from 'primereact/utils';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLoginMutation } from '../api/LoginAPI';
import { setLogin, setToken } from '../Slice/AuthSlice';
import { setDialogPasswordResetVisible, setLoginVisible, setModalMessageOkDialogVisible } from '../Slice/DialogSlice';
import { AppDispatch, RootState } from '../Store';
import { IThisToken, ProfileInfo } from '../types/Types';
import styles from './dialog.module.scss';

export default function AuthDialogLogin() {

    //const username = useSelector((state: RootState) => state.authReducer.auth.credentials?.username);
    //const password = useSelector((state: RootState) => state.authReducer.auth.credentials?.password);
    //const twophasecode = useSelector((state: RootState) => state.authReducer.auth.credentials?.twophasecode);
    const loginVisible = useSelector((state: RootState) => state.authReducer.dialog.loginVisible);
    const dispatch = useDispatch<AppDispatch>();
    const [loginAPI] = useLoginMutation();

    const [username, setUsername] = useState<string>('');
    const [password, setPassword] = useState<string>('');
    const [twophasecode, setTwophasecode] = useState<string>('');
    const [twofactorlogin, setTwofactorlogin] = useState<Boolean>(false);

    const handleLoginButton = (e: { preventDefault: () => void; target: any; }) => {
        e.preventDefault();

        loginAPI({ username: username, password: password, twophasecode: twophasecode })
            .then((resp) => {
                if (resp.error !== undefined && (resp.error as FetchBaseQueryError).status === 403) {
                    dispatch(setModalMessageOkDialogVisible({
                        visible: true,
                        text: 'Nutzername oder Passwort ist falsch',
                    }));
                } else {
                    const data = resp.data;

                    if (data?.token !== "") {

                        const thisToken: IThisToken = jwtDecode(data?.token!);

                        dispatch(setToken(resp!.data!.token));

                        setUsername("");
                        setPassword("");
                        setTwophasecode("");

                        const p: ProfileInfo = {
                            uid: thisToken.uid,
                            email: thisToken.sub!,
                            rollen: thisToken.roles,
                            auftraggeber: undefined
                        }

                        dispatch(setLogin(p));
                        dispatch(setLoginVisible(false));
                        setTwofactorlogin(false);

                    } else if (data?.errorText !== "") {

                        dispatch(setModalMessageOkDialogVisible({
                            visible: true,
                            text: 'Es ist ein Fehler aufgetreten: ' + data?.errorText,
                        }));

                    } else if (data?.is2fa) {

                        setTwofactorlogin(true);

                    }
                }
            })
            .catch(error => {
                dispatch(setModalMessageOkDialogVisible({
                    visible: true,
                    text: 'Es ist ein Fehler aufgetreten: ' + error,
                }));
            })
    }

    const headerContent = (
        <div className="">
            <h3>Login</h3>
        </div>
    );

    return (
        <Dialog
            header={headerContent}
            //footer={footerContent}
            visible={loginVisible}
            onHide={() => dispatch(setLoginVisible(false))}
        >
            {!twofactorlogin &&
                <>
                    <div className={classNames(styles.authDialogContent, 'p-dialog-content')}>
                        <form onSubmit={handleLoginButton}>

                            <div>
                                <div>
                                    <label htmlFor='input-auth-username' className={classNames(styles.contextFontBodyBoldL)}>Email</label>
                                </div>
                                <input
                                    className='form-control'
                                    id='input-auth-username'
                                    type='text'
                                    name="username"
                                    value={username}
                                    placeholder={''}
                                    onChange={(event) => {
                                        /*dispatch(setCredentials({
                                            username: event.target.value,
                                            password: password || '',
                                            twophasecode: twophasecode || ''
                                        }));*/
                                        event.stopPropagation(); setUsername(event.target.value);
                                    }}
                                    autoFocus
                                    tabIndex={0}
                                />
                            </div>
                            <div>
                                <div>
                                    <label htmlFor='input-auth-password' className={classNames(styles.contextFontBodyBoldL)}>Password</label>
                                </div>

                                <input type="password"
                                    className='form-control'
                                    id='input-auth-password'
                                    name="password"
                                    style={{ width: '100%' }}
                                    value={password}
                                    onChange={(event) => {
                                        /*dispatch(setCredentials({
                                            username: username || '',
                                            password: event.target.value,
                                            twophasecode: twophasecode || ''
                                        }));*/
                                        event.stopPropagation(); setPassword(event.target.value);
                                    }}
                                    tabIndex={1} />
                            </div>

                            <div className={classNames(styles.authDialogFooter)}>
                                <button
                                    type="submit"
                                    onClick={handleLoginButton}
                                    title="Login"
                                    className=" btn btn-primary"
                                    disabled={username === undefined || password === undefined}
                                >Login</button>
                            </div>
                        </form>
                        <button
                            title="Forgot Password"
                            className=" btn btn-light"
                            onClick={() => {
                                dispatch(setLoginVisible(false));
                                dispatch(setDialogPasswordResetVisible(true));
                            }}>Password vergessen</button>
                    </div>

                </>
            }

            {twofactorlogin &&
                <>
                    <div className={classNames(styles.authDialogContent, 'p-dialog-content')}>

                        <form onSubmit={handleLoginButton}>

                            <div>
                                <label htmlFor='input-auth-twophasecode' className={classNames(styles.contextFontBodyBoldL)}>Code</label>
                            </div>

                            <input
                                name="twophasecode"
                                className={classNames('p-inputtext', styles.authInputField)}
                                id='input-auth-twophasecode'
                                type='text'
                                maxLength={6}
                                value={twophasecode}
                                placeholder={''}
                                onChange={(event) => {
                                    /*dispatch(setCredentials({
                                        username: username || '',
                                        password: password || '',
                                        twophasecode: event.target.value,
                                    }));*/
                                    event.stopPropagation(); setTwophasecode(event.target.value);
                                }}
                                autoFocus
                                tabIndex={0}
                            />

                            <div className={styles.authDialogFooter}>
                                <button
                                    title="Login"
                                    className="btn btn-primary"
                                    disabled={username === undefined || password === undefined}
                                    onClick={() => handleLoginButton} > Login </button>
                                <button
                                    title="Zurück"
                                    className="btn btn-light"
                                    onClick={() => {
                                        setTwofactorlogin(false);
                                        /*dispatch(setCredentials({
                                            username: username || '',
                                            password: password || '',
                                            twophasecode: ''
                                        }));*/
                                    }}>Zurück</button>
                            </div>

                        </form>
                    </div>
                </>
            }
        </Dialog>
    )
}
